"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preparePosting = preparePosting;
exports.buildReversal = buildReversal;
const opening_balance_1 = require("./opening-balance");
const closing_1 = require("../closing/closing");
const money_1 = require("../money");
const invariants_1 = require("../ledger/invariants");
/**
 * يحوّل نية ترحيل إلى قيد جاهز للحفظ، أو يُرجع كل المشاكل المحاسبية.
 * دالة خالصة: لا قاعدة بيانات ولا وقت ولا عشوائية — كل السياق يأتى من ctx.
 * الحفظ والقفل وatomicity مسؤولية طبقة الـ API، وليست هنا.
 */
function preparePosting(intent, ctx) {
    const issues = [];
    if (intent.companyId !== ctx.companyId) {
        issues.push({
            code: 'COMPANY_MISMATCH',
            message: 'intent company does not match posting context company',
        });
    }
    issues.push(...(0, invariants_1.checkPeriod)(intent.postingDate, ctx));
    // الإعفاء بنوع المصدر، ومسار القيد الحر يرفض هذا النوع (DATA_MIGRATION_RESERVED)
    const lineOptions = { taxSnapshotOptional: intent.sourceType === 'data_migration' };
    intent.lines.forEach((line, index) => {
        issues.push(...(0, invariants_1.checkLine)(line, index, ctx, lineOptions).issues);
    });
    issues.push(...(0, invariants_1.checkBalanced)(intent.lines));
    if (intent.sourceType === 'opening_balance') {
        issues.push(...(0, opening_balance_1.checkOpeningBalance)(intent, ctx));
    }
    if (intent.sourceType === 'period_close') {
        issues.push(...(0, closing_1.checkPeriodClose)(intent, ctx));
    }
    issues.push(...(0, invariants_1.checkCashboxes)(intent.lines, ctx));
    if (issues.length > 0) {
        return { ok: false, issues };
    }
    return {
        ok: true,
        value: {
            companyId: intent.companyId,
            fiscalPeriodId: ctx.fiscalPeriod.id,
            postingDate: intent.postingDate,
            status: 'POSTED',
            sourceType: intent.sourceType,
            sourceId: intent.sourceId,
            idempotencyKey: intent.idempotencyKey,
            reference: intent.reference ?? null,
            memo: intent.memo ?? null,
            totalDebit: money_1.Money.sum(intent.lines.map((line) => line.debit)).normalize(),
            totalCredit: money_1.Money.sum(intent.lines.map((line) => line.credit)).normalize(),
            lines: intent.lines,
        },
    };
}
/**
 * القيد المنشور لا يُعدَّل أبدًا فى مكانه — التصحيح بقيد عكسى موثق.
 * السطور تُقلب (مدين ↔ دائن) مع الاحتفاظ بالطرف المقابل وأثر الضريبة.
 */
function buildReversal(journal, options) {
    const lines = journal.lines.map((line) => ({
        ...line,
        debit: line.credit,
        credit: line.debit,
        memo: options.reason,
    }));
    return {
        companyId: journal.companyId,
        sourceType: 'reversal',
        sourceId: journal.sourceId,
        postingDate: options.postingDate,
        idempotencyKey: options.idempotencyKey,
        lines,
        reference: journal.reference,
        memo: options.reason,
        createdBy: options.createdBy ?? null,
    };
}
//# sourceMappingURL=posting-engine.js.map